import { nextTick, useTemplateRef, watch, type ShallowRef } from 'vue'
import type ProductGrid from '@/components/rings/product-grid/ProductGrid.vue'
import type { ReadonlyRef } from '@/helpers'

interface FocusFilterButton {
    // @ts-expect-error
    gridNode: Readonly<ShallowRef<InstanceType<typeof ProductGrid>>>
}

export function useFocusFilterButton(
    isFiltersModalOpen: ReadonlyRef<boolean>
): FocusFilterButton {
    const gridNode =
        // @ts-expect-error
        useTemplateRef<InstanceType<typeof ProductGrid>>('gridNode')

    watch(isFiltersModalOpen, (isOpen) => {
        if (!isOpen) {
            nextTick(() => gridNode.value?.filterButtonEl?.focus())
        }
    })

    return { gridNode }
}
